exports = module.exports = require("../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".LoginPage__LoginPage__3eADY {\n  font-size: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"LoginPage": "LoginPage__LoginPage__3eADY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/Auth/LoginPage/LoginPage.css
// module id = 876
// module chunks = 0